import { render, staticRenderFns } from "./KioskScreensaver.vue?vue&type=template&id=0d382f14&"
import script from "./KioskScreensaver.vue?vue&type=script&lang=js&"
export * from "./KioskScreensaver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports